import { BackStoryRole } from "@src/@types/api.d";
import toast from "react-hot-toast";

export const copyToClipboard = (text: string, alert: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success(<p className="toast">{alert}</p>);
    })
    .catch((err) => {
      toast.error(<p>An Error occurred while copying</p>);
    });
};

export const objectKeyToWord = (key: string) => {
  const res: string[] = [];
  key
    .split("_")
    .forEach((i) => res.push(`${i[0].toUpperCase()}${i.slice(1, i.length)}`));
  return res.join(" ");
};

export const formatMoney = (n: number) => {
  const res = new Intl.NumberFormat().format(n);
  return res;
};

export const decodeHtmlEntities = (value?: string | null): string => {
  if (!value) return "";

  const namedEntities: Record<string, string> = {
    amp: "&",
    lt: "<",
    gt: ">",
    quot: '"',
    apos: "'",
  };

  const decodeOnce = (input: string): string =>
    input.replace(/&(#x[0-9a-fA-F]+|#\d+|[a-zA-Z]+);/g, (entity, token) => {
      const named = namedEntities[token];
      if (named !== undefined) {
        return named;
      }

      if (token.startsWith("#x") || token.startsWith("#X")) {
        const parsed = Number.parseInt(token.slice(2), 16);
        return Number.isNaN(parsed) ? entity : String.fromCodePoint(parsed);
      }

      if (token.startsWith("#")) {
        const parsed = Number.parseInt(token.slice(1), 10);
        return Number.isNaN(parsed) ? entity : String.fromCodePoint(parsed);
      }

      return entity;
    });

  let decoded = value;
  for (let i = 0; i < 3; i += 1) {
    const next = decodeOnce(decoded);
    if (next === decoded) break;
    decoded = next;
  }

  return decoded;
};

export function getTimeRemaining(endDate: Date): {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
} {
  const now = new Date();
  const timeRemaining = endDate.getTime() - now.getTime();

  const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds };
}

export const getRole = (role: BackStoryRole | undefined) => {
  if (role === "Both") {
    return "The Couple";
  }
  return role;
};
